<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="add-config-dialog"
  >
    <div class="form-content">
      <config-form
        :form-data="formData"
        ref="outform"
        @submit="submit"
      ></config-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import configForm from "@/components/sys/config/configForm";
import {editConfig} from "@/api/sys/config/config";

export default {
  name: "editRoleDialog",
  components: {
    configForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default(){
        return {
          id: '',
        }
      }
    }
  },
  data() {
    return {
      title: '编辑',
    }
  },
  watch:{
    dialogShow(newValue){
      if(newValue && this.formData.id){
        setTimeout(() => {
          this.$refs.outform.assigen(this.formData);
        },200);
      }
    },
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        id: form.id,
        paramKey: form.paramKey,
        paramValue: form.paramValue,
        'remark': form.remark,
      }
      editConfig(params).then((data) => {
        if(data && data.code===200){
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message({
            message: data.msg,
            type: 'error'
          });
        }
        
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style scoped>

</style>
